module.exports = __webpack_public_path__ + "img/deema.7de5d1b3.png";